// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import transition css modules
import transitionStyles from '../transitionModuleStyles.css';

function TransitionListItem({ transition }) {
  return (
    <li>
      <Link to={`/transitions/${transition._id}`}> {transition.name}</Link>
    </li>
  )
}

TransitionListItem.propTypes = {
  transition: PropTypes.object.isRequired
}

export default TransitionListItem;



// WEBPACK FOOTER //
// modules/transition/components/TransitionListItem.js.jsx